import { render, staticRenderFns } from "./ApplyList.vue?vue&type=template&id=3f94b792"
import script from "./ApplyList.vue?vue&type=script&lang=js"
export * from "./ApplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f94b792')) {
      api.createRecord('3f94b792', component.options)
    } else {
      api.reload('3f94b792', component.options)
    }
    module.hot.accept("./ApplyList.vue?vue&type=template&id=3f94b792", function () {
      api.rerender('3f94b792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/ApplyList.vue"
export default component.exports